var _ellipse, _mask, _g, _mask2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardOpening({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48,
    cy: 48,
    rx: 48,
    ry: 48,
    fill: "#EEF0F2",
    fillOpacity: 0.6
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 96
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 48,
    cy: 48,
    rx: 48,
    ry: 48,
    fill: "#EEF0F2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5.21802,
    y: 64.6956,
    width: 106.435,
    height: 31.3044,
    fill: "#DFE1E5"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 96
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 48,
    cy: 48,
    rx: 48,
    ry: 48,
    fill: "#EEF0F2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.1002,
    y: 74.7653,
    width: 59.23,
    height: 2.46924,
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7396 41.1423L73.3654 41.1423L73.3654 30.0264L73.374 30.0264L47.2257 21.4655C47.1153 21.4294 46.9964 21.4294 46.886 21.4655L20.7448 30.0241L20.7396 30.0241L20.7396 30.0258L20.7377 30.0264L20.7396 30.0264L20.7396 41.1423Z",
    fill: "#76A7F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.7377,
    y: 40.7975,
    width: 52.6258,
    height: 0.370608,
    fill: "#4788F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7357 41.1683H73.3616V74.5362C73.3616 74.9381 73.0358 75.2639 72.6339 75.2639H21.4634C21.0615 75.2639 20.7357 74.9381 20.7357 74.5362V41.1683Z",
    fill: "#295BA4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.5984,
    y: 15.3585,
    width: 28.1659,
    height: 38.9135,
    rx: 0.545791,
    transform: "rotate(38.7937 51.5984 15.3585)",
    fill: "#E4E5E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.5195,
    y: 15.3376,
    width: 28.166,
    height: 38.9135,
    rx: 0.545791,
    transform: "rotate(13.1904 38.5195 15.3376)",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 52.3203,
    y: 24.6628,
    width: 8.89451,
    height: 1.85302,
    rx: 0.926511,
    transform: "rotate(13.1904 52.3203 24.6628)",
    fill: "#CCD0D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.1752,
    y: 34.67,
    width: 17.0478,
    height: 1.85302,
    rx: 0.926511,
    transform: "rotate(13.1904 38.1752 34.67)",
    fill: "#CCD0D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.2461,
    y: 38.6394,
    width: 11.1181,
    height: 1.85302,
    rx: 0.92651,
    transform: "rotate(13.1904 37.2461 38.6394)",
    fill: "#CCD0D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.2305,
    y: 42.9691,
    width: 15.1948,
    height: 1.85302,
    rx: 0.92651,
    transform: "rotate(13.1904 36.2305 42.9691)",
    fill: "#CCD0D4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.1639,
    cy: 23.603,
    rx: 4.27392,
    ry: 4.27392,
    transform: "rotate(13.1904 44.1639 23.603)",
    fill: "#288840"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 44.1642,
    cy: 23.6032,
    rx: 3.3521,
    ry: 3.3521,
    transform: "rotate(13.1904 44.1642 23.6032)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6807 21.4001C45.1999 21.5218 45.5215 22.0358 45.4008 22.5509C45.2801 23.066 44.7636 23.3835 44.2444 23.2618C43.7252 23.1401 43.4035 22.6261 43.5242 22.1111C43.6449 21.596 44.1615 21.2785 44.6807 21.4001ZM43.6481 25.8061C42.8661 25.6228 42.268 25.0637 42.0056 24.3672C42.1597 23.7519 43.4807 23.7047 44.1062 23.8513C44.7286 23.9972 45.8941 24.6272 45.7588 25.2468C45.2143 25.7542 44.43 25.9893 43.6481 25.8061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7357 41.5391H73.3616V74.5364C73.3616 74.9383 73.0358 75.2641 72.6339 75.2641H21.4634C21.0615 75.2641 20.7357 74.9383 20.7357 74.5364V41.5391Z",
    fill: "#4788F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.9824,
    y: 62.1856,
    width: 10.4287,
    height: 10.7324,
    transform: "rotate(-45 42.9824 62.1856)",
    fill: "url(#paint2_linear)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9829 43.4147H71.1161V73.0538C71.1161 73.4432 70.8004 73.7588 70.4111 73.7588H23.6879C23.2986 73.7588 22.9829 73.4432 22.9829 73.0538V43.4147Z",
    stroke: "#0047BB",
    strokeOpacity: 0.6,
    strokeWidth: 0.0454826
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.069 54.8112H50.4828V59.4856C50.4828 61.809 48.5993 63.6925 46.2759 63.6925C43.9525 63.6925 42.069 61.809 42.069 59.4856V54.8112Z",
    fill: "#F5B52C"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 54,
    width: 9,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.069 54.8112H50.4828V59.4856C50.4828 61.809 48.5993 63.6925 46.2759 63.6925C43.9525 63.6925 42.069 61.809 42.069 59.4856V54.8112Z",
    fill: "#F5B52C"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8625 54.8112H46.2764V63.6925H43.5992C40.4309 63.6925 37.8625 61.1241 37.8625 57.9559V54.8112Z",
    fill: "#F5992C",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("rect", {
    x: 27.4076,
    y: 48.5804,
    width: 9.26512,
    height: 0.74121,
    fill: "#1C61D1",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8158 49.3216H36.2638V53.5456C36.2638 55.8784 34.3726 57.7696 32.0398 57.7696C29.7069 57.7696 27.8158 55.8784 27.8158 53.5456V49.3216Z",
    fill: "#76A7F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 72.4163,
    y1: 74.7653,
    x2: 8.24403,
    y2: 74.7653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 60.5608,
    y1: 18.9549,
    x2: 43.1615,
    y2: 43.8331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 48.1968,
    y1: 62.1856,
    x2: 48.1968,
    y2: 72.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardOpening);
export default __webpack_public_path__ + "static/media/dashboardOpening.bef3feec325be920f2c4b9ddf48dc6f3.svg";
export { ForwardRef as ReactComponent };